var styleDataHash = "7ed1d270";
const injectCss = () => {
  var css = `.bDs6S{height:100%;position:absolute;top:0;width:100%;z-index:0}[dir] .bDs6S{border:0}[dir=ltr] .bDs6S{left:0}[dir=rtl] .bDs6S{right:0}.PbiA-{bottom:0;position:absolute;top:0;z-index:3}[dir=ltr] .PbiA-,[dir=rtl] .PbiA-{left:0;right:0}.iQs-1{height:0;position:relative}[dir] .iQs-1{padding-bottom:56.25%}@supports not (contain:inline-size){@media only screen and (max-width:640px){.iQs-1{min-width:auto}}}@container (width < 640px){.iQs-1{min-width:auto}}.NQT1L{bottom:0;height:100%;position:absolute;top:0;width:100%;z-index:1}[dir] .NQT1L{cursor:move}.NQT1L~*>*{pointer-events:none}.x--gR{height:0;overflow:hidden;visibility:hidden;width:0}.WOiO9,.x--gR{position:absolute}.WOiO9{align-items:center;color:#fff;display:flex;font-size:20px;font-weight:400;height:100%;justify-content:center;top:0;width:100%;z-index:1}[dir] .WOiO9{background:rgba(0,0,0,.5);text-align:center}[dir=ltr] .WOiO9{right:0}[dir=rtl] .WOiO9{left:0}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var default_video_styles_default = {
  "video_player": "bDs6S",
  "videoOverlay": "PbiA-",
  "video_container": "iQs-1",
  "video_overlay": "NQT1L",
  "hide_duration": "x--gR",
  "error": "WOiO9"
};
export {
  default_video_styles_default as default,
  injectCss
};
//# sourceMappingURL=default-video-styles-scss.js.map
